// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"f464d92ee06a8341","9751":"5c5cc9e6436a347e"}[chunkId] + ".css";
};